import {Button} from "@mui/material";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import {StyledButton} from "components/FileManager/styledComps/StyledButton";
import React from "react";
import Success from "assets/svg/success.svg";
import Warning from "assets/images/Warning.svg";

// import { withRouter } from "./WithRouter";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, reload: 0, showAlert: false};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        console.log("Error : =======================>  ", error);
        console.log("ErrorInfo : =======================>  ", errorInfo);
    }

    sendLog = () => {
        this.setState({showAlert: true});
        setTimeout(() => {
            this.setState({showAlert: false});

            const url = window.location.pathname;
            let prev = url.split("/");
            prev = "/" + prev[prev.length - 2];
            window.location.href = prev;
        }, 3500);
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        height: "100vh",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {this.state.showAlert ? (
                        <div className={"warp-alert-success"}>
                            <div className="img-exit">
                                <img src={Success} alt="exitImgSuccess"/>
                            </div>
                            <div>گزارش مشکل به پشتیبانی چرتکه ارسال شد</div>
                        </div>
                    ) : null}
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <img src={Warning} alt=""/>
                        <p style={{color: "#323A44", fontSize: "24px", fontWeight: 700}}>یک مشکل فنی پیش آمده</p>
                        <div style={{color: "#576271", fontSize: "16px", fontWeight: 400}}>
                            <p>جهت بازنشانی صفحه دکمه های Ctrl + Shift + R را روی کیبرد سیستم خود بزنید</p>
                            <p style={{color: "#444E5B"}}>در صورت حل نشدن مشکل، برای تسریع فرایند لطفا گزارش خطا را به پشتیبانی ارسال کنید</p>
                            <p>تلاش میکنیم در کوتاه ترین زمان ممکن آن را برطرف کنیم</p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "30px",
                                marginTop: "20px",
                            }}
                        >
                            <Button
                                style={{width: "fit-content", fontFamily: "IRANSansFaNum"}}
                                variant="contained"
                                color="primary"
                                onClick={() => this.sendLog()}
                            >
                                ارسال گزارش به پشتیبانی چرتکه
                            </Button>
                            <StyledButton
                                style={{width: "fit-content", fontFamily: "IRANSansFaNum"}}
                                variant="text"
                                color="primary"
                                endIcon={<ArrowBackIcon variant="blue"/>}
                                onClick={() => {
                                    const url = window.location.pathname;
                                    let prev = url.split("/");
                                    prev = "/" + prev[prev.length - 2];
                                    window.location.href = prev;
                                }}
                            >
                                بازگشت
                            </StyledButton>
                        </div>
                    </div>
                </div>
            );
        }
        return <>{this.props.children}</>;
    }
}

export default ErrorBoundary;
